import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ship-list-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-bg" }
const _hoisted_4 = {
  viewBox: "0 0 64 64",
  class: "compass-deco",
  "aria-hidden": "true"
}
const _hoisted_5 = ["transform"]
const _hoisted_6 = { class: "title-block" }
const _hoisted_7 = { class: "page-title" }
const _hoisted_8 = { class: "header-actions" }
const _hoisted_9 = {
  key: 0,
  class: "last-refresh"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "stat-row" }
const _hoisted_12 = { class: "stat-card stat-total" }
const _hoisted_13 = { class: "stat-card-top" }
const _hoisted_14 = { class: "stat-icon-ring" }
const _hoisted_15 = { class: "stat-icon" }
const _hoisted_16 = { class: "stat-body" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "stat-card stat-online" }
const _hoisted_19 = { class: "stat-card-top" }
const _hoisted_20 = { class: "stat-icon-ring" }
const _hoisted_21 = { class: "stat-icon" }
const _hoisted_22 = { class: "stat-body" }
const _hoisted_23 = { class: "stat-value" }
const _hoisted_24 = { class: "stat-tip" }
const _hoisted_25 = { class: "stat-card stat-offline" }
const _hoisted_26 = { class: "stat-card-top" }
const _hoisted_27 = { class: "stat-icon-ring" }
const _hoisted_28 = { class: "stat-icon" }
const _hoisted_29 = { class: "stat-body" }
const _hoisted_30 = { class: "stat-value" }
const _hoisted_31 = { class: "stat-card stat-authorized" }
const _hoisted_32 = { class: "stat-card-top" }
const _hoisted_33 = { class: "stat-icon-ring" }
const _hoisted_34 = { class: "stat-icon" }
const _hoisted_35 = { class: "stat-body" }
const _hoisted_36 = { class: "stat-value" }
const _hoisted_37 = { class: "toolbar" }
const _hoisted_38 = { class: "result-tag" }
const _hoisted_39 = { class: "fleet-section" }
const _hoisted_40 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_41 = {
  key: 1,
  class: "ship-grid"
}
const _hoisted_42 = { class: "ship-card-head" }
const _hoisted_43 = { class: "card-avatar" }
const _hoisted_44 = { class: "card-title" }
const _hoisted_45 = ["title"]
const _hoisted_46 = { class: "card-org" }
const _hoisted_47 = { class: "ship-card-body" }
const _hoisted_48 = { class: "auth-status-row" }
const _hoisted_49 = { class: "auth-block" }
const _hoisted_50 = {
  key: 0,
  class: "auth-time"
}
const _hoisted_51 = { class: "time-chip" }
const _hoisted_52 = { class: "time-chip" }
const _hoisted_53 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_54 = { class: "info-item create-time" }
const _hoisted_55 = { class: "info-value" }
const _hoisted_56 = { class: "ship-card-foot" }
const _hoisted_57 = {
  class: "action-chip action-more",
  type: "button"
}
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "pagination-bar" }
const _hoisted_61 = {
  key: 0,
  class: "apply-result"
}
const _hoisted_62 = {
  key: 1,
  class: "apply-result"
}
const _hoisted_63 = {
  key: 2,
  class: "apply-form"
}
const _hoisted_64 = { class: "apply-ship-name" }
const _hoisted_65 = { class: "apply-ship-icon" }
const _hoisted_66 = { class: "title-text" }

import { computed, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import {
  ArrowRight,
  CaretBottom,
  CircleClose,
  Compass,
  Document,
  Key,
  OfficeBuilding,
  Refresh,
  Search,
  Setting,
  Ship,
  View,
} from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import {
  getShipAuthorityListApi,
  getShipListApi,
  submitShipAuthorizationApplyApi,
} from "@/api/productApi";
import { fetchOrganizationListApi } from "@/api/organization/organizationApi";
import type {
  ApplyShipAuthorizationParams,
  Ship as ShipEntity,
  ShipListItem,
} from "@/types/product";
import type { Authority } from "@/types/resource";
import type { Organization } from "@/types/organization";
import { getName } from "@/util/i18nUtil";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShipListView',
  setup(__props) {

const router = useRouter();

const loading = ref<boolean>(false);
const submitting = ref<boolean>(false);
const queryName = ref<string>("");
const queryOrgId = ref<string>("");
const onlineFilter = ref<string>("");
const authFilter = ref<string>("");
const orgList = ref<Organization[]>([]);
const shipList = ref<ShipListItem[]>([]);
const authorizedTotal = ref<number>(0);
const lastRefreshTime = ref<string>("");
const page = reactive({ current: 1, size: 10, total: 0 });

/**
 * 全量统计（统计卡片专用）
 * 后端基于名称/集团条件返回全量口径统计，不受在线/授权筛选影响
 */
const stats = reactive({ shipTotal: 0, onlineTotal: 0, offlineTotal: 0 });

/**
 * 全量在线率（在线船舶 / 船舶总数）
 */
const onlineRate = computed(() =>
  stats.shipTotal === 0
    ? 0
    : Math.round((stats.onlineTotal / stats.shipTotal) * 100)
);

const totalProgressStyle = computed(() => ({
  background: `conic-gradient(#1e3799 ${Math.min(
    onlineRate.value,
    100
  )}%, rgba(30, 55, 153, 0.12) 0)`,
}));

const authStatusText = (auth: ShipListItem["authorization"]) => {
  if (!auth) return "未授权";
  if (auth.status === 1) return "已授权";
  return "授权中";
};

const authStatusClass = (auth: ShipListItem["authorization"]) => {
  if (!auth) return "auth-red";
  if (auth.status === 1) return "auth-green";
  return "auth-yellow";
};

const formatDate = (iso: string) =>
  new Date(iso).toLocaleString("zh-CN", { hour12: false });

const fetchShipList = async () => {
  loading.value = true;
  const result = await getShipListApi({
    current: page.current,
    size: page.size,
    name: queryName.value || undefined,
    orgId: queryOrgId.value || undefined,
    onlineFilter: onlineFilter.value || undefined,
    authFilter: authFilter.value || undefined,
  });
  if (result) {
    shipList.value = result.page.records;
    page.total = result.page.total;
    authorizedTotal.value = result.authorizedTotal;
    stats.shipTotal = result.shipTotal;
    stats.onlineTotal = result.onlineTotal;
    stats.offlineTotal = result.offlineTotal;
    lastRefreshTime.value = new Date().toLocaleTimeString();
  } else {
    ElMessage.error("船舶列表加载失败");
  }
  loading.value = false;
};

const fetchOrganizations = async () => {
  const list = await fetchOrganizationListApi({
    name: "",
    page: 1,
    size: 1000,
  });
  if (list) orgList.value = list;
};

const handleOrgChange = () => {
  page.current = 1;
  fetchShipList();
};

const handleSearch = () => {
  page.current = 1;
  fetchShipList();
};

const handleReset = () => {
  queryName.value = "";
  queryOrgId.value = "";
  onlineFilter.value = "";
  authFilter.value = "";
  page.current = 1;
  fetchShipList();
};

const handlePageChange = (current: number) => {
  page.current = current;
  fetchShipList();
};

const handleSizeChange = (size: number) => {
  page.size = size;
  page.current = 1;
  fetchShipList();
};

const goProtocolFile = (row: ShipListItem) => {
  router.push({ path: "/protocol_file", query: { shipId: row.ship.id } });
};

const goCalcParam = (row: ShipListItem) => {
  router.push({ name: "shipCalcParam", query: { shipId: row.ship.id } });
};

const goShipInfo = (row: ShipListItem) => {
  router.push({ name: "shipInfo", query: { shipId: row.ship.id } });
};

const applyDialogVisible = ref<boolean>(false);
const applyResult = ref<-1 | 0 | 1>(-1);
const selectedShip = ref<ShipEntity | undefined>(undefined);
const datetimeRange = ref<[Date, Date] | []>([]);
const shipAuthorityList = ref<Authority[]>([]);
const applyParams = reactive<ApplyShipAuthorizationParams>({
  shipId: "",
  orgId: "",
  startTime: "",
  endTime: "",
  description: "",
  authorityId: null,
});

const shortcuts = [
  {
    text: "三小时",
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setHours(end.getHours() + 3);
      return [start, end];
    },
  },
  {
    text: "一天",
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setDate(end.getDate() + 1);
      return [start, end];
    },
  },
  {
    text: "一星期",
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setDate(end.getDate() + 7);
      return [start, end];
    },
  },
  {
    text: "一个月",
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setMonth(end.getMonth() + 1);
      return [start, end];
    },
  },
];

const openApplyAuthorization = async (row: ShipListItem) => {
  selectedShip.value = row.ship;
  applyParams.shipId = row.ship.id;
  applyParams.orgId = row.ship.orgId ?? "";
  applyParams.authorityId = null;
  applyParams.description = "";
  applyParams.startTime = "";
  applyParams.endTime = "";
  datetimeRange.value = [];
  applyResult.value = -1;
  if (shipAuthorityList.value.length === 0) {
    const list = await getShipAuthorityListApi();
    if (list) shipAuthorityList.value = list;
  }
  applyDialogVisible.value = true;
};

const submitApply = async () => {
  if (!applyParams.authorityId) {
    ElMessage.warning("请选择授权类型");
    return;
  }
  if (!Array.isArray(datetimeRange.value) || datetimeRange.value.length !== 2) {
    ElMessage.warning("请选择授权时段");
    return;
  }
  const [start, end] = datetimeRange.value as [Date, Date];
  if (end <= start) {
    ElMessage.warning("结束时间需晚于开始时间");
    return;
  }
  applyParams.startTime = start.toISOString();
  applyParams.endTime = end.toISOString();

  submitting.value = true;
  const response = await submitShipAuthorizationApplyApi({ ...applyParams });
  submitting.value = false;

  if (response != null) {
    applyResult.value = 1;
    ElMessage.success("授权申请已提交，等待用户确认");
    fetchShipList();
  } else {
    applyResult.value = 0;
    ElMessage.error("授权申请提交失败，请重试");
  }
};

const closeApplyDialog = () => {
  applyDialogVisible.value = false;
};

const handleApplyDialogClose = (done: () => void) => {
  done();
  setTimeout(() => {
    selectedShip.value = undefined;
    applyResult.value = -1;
    datetimeRange.value = [];
    applyParams.authorityId = null;
    applyParams.description = "";
    applyParams.startTime = "";
    applyParams.endTime = "";
  }, 300);
};

onMounted(() => {
  fetchOrganizations();
  fetchShipList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createStaticVNode("<svg viewBox=\"0 0 800 200\" preserveAspectRatio=\"none\" class=\"header-svg\" data-v-550ea509><circle cx=\"100\" cy=\"100\" r=\"180\" fill=\"rgba(255,255,255,0.05)\" data-v-550ea509></circle><circle cx=\"650\" cy=\"40\" r=\"150\" fill=\"rgba(8,145,178,0.20)\" data-v-550ea509></circle><circle cx=\"780\" cy=\"180\" r=\"90\" fill=\"rgba(255,255,255,0.06)\" data-v-550ea509></circle><path d=\"M 0 150 Q 200 100 400 130 T 800 110\" stroke=\"rgba(255,255,255,0.10)\" stroke-width=\"1\" fill=\"none\" data-v-550ea509></path><path d=\"M 0 170 Q 220 140 420 160 T 800 140\" stroke=\"rgba(255,255,255,0.05)\" stroke-width=\"1\" fill=\"none\" data-v-550ea509></path></svg>", 1)),
        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("circle", {
            cx: "32",
            cy: "32",
            r: "28",
            fill: "none",
            stroke: "rgba(255,255,255,0.18)",
            "stroke-width": "1.2"
          }, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("circle", {
            cx: "32",
            cy: "32",
            r: "20",
            fill: "none",
            stroke: "rgba(255,255,255,0.10)",
            "stroke-width": "1"
          }, null, -1)),
          _cache[13] || (_cache[13] = _createElementVNode("circle", {
            cx: "32",
            cy: "32",
            r: "3",
            fill: "rgba(255,255,255,0.8)"
          }, null, -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
            return _createElementVNode("g", {
              key: i,
              transform: `rotate(${(i - 1) * 45} 32 32)`
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("rect", {
                x: "31.2",
                y: "6",
                width: "1.6",
                height: "6",
                fill: "rgba(255,255,255,0.45)",
                rx: "0.6"
              }, null, -1)
            ]))], 8, _hoisted_5)
          }), 64)),
          _cache[14] || (_cache[14] = _createElementVNode("polygon", {
            points: "32,10 34,32 32,32",
            fill: "rgba(255,255,255,0.85)"
          }, null, -1)),
          _cache[15] || (_cache[15] = _createElementVNode("polygon", {
            points: "32,54 30,32 32,32",
            fill: "rgba(165,243,252,0.55)"
          }, null, -1))
        ]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "hero-tag" }, "RACERN · FLEET", -1)),
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("r.ship_list")), 1),
        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "page-desc" }, " 跨集团检索全部船舶，实时掌握在线状态、终端绑定与授权情况 ", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (lastRefreshTime.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "live-dot" }, null, -1)),
              _createTextVNode(" 上次刷新 · " + _toDisplayString(lastRefreshTime.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["refresh-btn", { loading: loading.value }]),
          disabled: loading.value,
          onClick: fetchShipList
        }, [
          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "ripple" }, null, -1)),
          _createVNode(_component_el_icon, { class: "refresh-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Refresh))
            ]),
            _: 1
          }),
          _cache[21] || (_cache[21] = _createElementVNode("span", null, "刷新", -1))
        ], 10, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "stat-card-glow" }, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              class: "ring-progress",
              style: _normalizeStyle(totalProgressStyle.value)
            }, null, 4),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Ship))
                ]),
                _: 1
              })
            ])
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "stat-badge" }, "FLEET", -1))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "stat-label" }, "船舶总数", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(stats.shipTotal), 1),
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "stat-unit" }, "艘", -1))
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "stat-tip" }, "全部集团的船舶数量", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "stat-card-glow" }, null, -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "ring-pulse" }, null, -1)),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Compass))
                ]),
                _: 1
              })
            ])
          ]),
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "stat-badge live" }, "LIVE", -1))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "stat-label" }, "在线船舶", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createTextVNode(_toDisplayString(stats.onlineTotal), 1),
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "stat-unit" }, "艘", -1))
          ]),
          _createElementVNode("div", _hoisted_24, "全量统计 · 在线率 " + _toDisplayString(onlineRate.value) + "%", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "stat-card-glow" }, null, -1)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(CircleClose))
                ]),
                _: 1
              })
            ])
          ]),
          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "stat-badge muted" }, "OFF", -1))
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "stat-label" }, "离线船舶", -1)),
          _createElementVNode("div", _hoisted_30, [
            _createTextVNode(_toDisplayString(stats.offlineTotal), 1),
            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "stat-unit" }, "艘", -1))
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "stat-tip" }, "全量统计", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "stat-card-glow" }, null, -1)),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(View))
                ]),
                _: 1
              })
            ])
          ]),
          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "stat-badge" }, "已授权", -1))
        ]),
        _createElementVNode("div", _hoisted_35, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "stat-label" }, "已授权船舶", -1)),
          _createElementVNode("div", _hoisted_36, [
            _createTextVNode(_toDisplayString(authorizedTotal.value), 1),
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "stat-unit" }, "艘", -1))
          ]),
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "stat-tip" }, "全表有效授权去重计数", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_el_select, {
        modelValue: queryOrgId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryOrgId).value = $event)),
        class: "org-select",
        placeholder: "选择集团",
        clearable: "",
        onChange: handleOrgChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部集团",
            value: ""
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgList.value, (org) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: org.id,
              label: org.name,
              value: org.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: queryName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryName).value = $event)),
        class: "query-input",
        placeholder: "搜索船舶名称…",
        clearable: "",
        onKeyup: _withKeys(handleSearch, ["enter"]),
        onClear: handleSearch
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Search))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: onlineFilter.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((onlineFilter).value = $event)),
        class: "filter-select",
        placeholder: "在线状态",
        clearable: "",
        onChange: handleSearch
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "在线",
            value: "online"
          }),
          _createVNode(_component_el_option, {
            label: "离线",
            value: "offline"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: authFilter.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((authFilter).value = $event)),
        class: "filter-select",
        placeholder: "授权状态",
        clearable: "",
        onChange: handleSearch
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "已授权",
            value: "authorized"
          }),
          _createVNode(_component_el_option, {
            label: "授权中",
            value: "authorizing"
          }),
          _createVNode(_component_el_option, {
            label: "未授权",
            value: "unauthorized"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "search-btn",
        loading: loading.value,
        onClick: handleSearch
      }, {
        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
          _createTextVNode("搜索", -1)
        ]))]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_el_button, {
        class: "reset-btn",
        onClick: handleReset
      }, {
        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
          _createTextVNode("重置", -1)
        ]))]),
        _: 1
      }),
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "toolbar-spacer" }, null, -1)),
      _createElementVNode("div", _hoisted_38, [
        _cache[44] || (_cache[44] = _createElementVNode("span", { class: "result-dot" }, null, -1)),
        _createTextVNode(" 当前页 " + _toDisplayString(shipList.value.length) + " 艘 / 共 " + _toDisplayString(page.total) + " 艘 ", 1)
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
      (shipList.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[46] || (_cache[46] = [
            _createStaticVNode("<svg viewBox=\"0 0 120 120\" class=\"empty-svg\" aria-hidden=\"true\" data-v-550ea509><circle cx=\"60\" cy=\"60\" r=\"40\" fill=\"none\" stroke=\"#cbd5e1\" stroke-width=\"2\" data-v-550ea509></circle><line x1=\"40\" y1=\"40\" x2=\"80\" y2=\"80\" stroke=\"#94a3b8\" stroke-width=\"2\" data-v-550ea509></line></svg><div class=\"empty-title\" data-v-550ea509>暂无符合条件的船舶</div><div class=\"empty-desc\" data-v-550ea509>调整搜索或筛选条件后重新查询</div>", 3)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shipList.value, (row) => {
              return (_openBlock(), _createElementBlock("div", {
                key: row.ship.id,
                class: "ship-card"
              }, [
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "ship-card-top" }, null, -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Ship))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", {
                      class: _normalizeClass(["online-dot", { show: row.status?.id === 1 }])
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", {
                      class: "card-name",
                      title: row.ship.name
                    }, _toDisplayString(row.ship.name), 9, _hoisted_45),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_el_icon, { class: "org-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OfficeBuilding))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(row.orgName ?? "未关联集团"), 1)
                    ])
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-pill", row.status?.id === 1 ? 'online' : 'offline'])
                  }, [
                    _cache[47] || (_cache[47] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
                    _createTextVNode(_toDisplayString(row.status?.cname ?? "-"), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _cache[48] || (_cache[48] = _createElementVNode("span", { class: "info-label" }, "授权状态", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["auth-status", authStatusClass(row.authorization)])
                    }, _toDisplayString(authStatusText(row.authorization)), 3)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "info-label" }, "授权时段", -1)),
                    (row.authorization)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, _toDisplayString(formatDate(row.authorization.startTime)), 1),
                          _createVNode(_component_el_icon, { class: "time-arrow" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ArrowRight))
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_52, _toDisplayString(formatDate(row.authorization.endTime)), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_53, "未授权"))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "info-label" }, "创建时间", -1)),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(row.ship.createtime || "—"), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_el_dropdown, {
                    trigger: "click",
                    "hide-on-click": true,
                    "popper-class": "ship-card-dropdown"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, { class: "ship-card-dropdown" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: ($event: any) => (goProtocolFile(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Document))
                                ]),
                                _: 1
                              }),
                              _cache[52] || (_cache[52] = _createElementVNode("span", null, "终端文件", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: ($event: any) => (goCalcParam(row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Setting))
                                ]),
                                _: 1
                              }),
                              _cache[53] || (_cache[53] = _createElementVNode("span", null, "参数配置", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_57, [
                        _cache[51] || (_cache[51] = _createElementVNode("span", null, "更多", -1)),
                        _createVNode(_component_el_icon, { class: "caret" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CaretBottom))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  (row.authorization)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        disabled: row.authorization.status === 1,
                        content: "授权申请待客户确认，或已被拒绝/过期",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: _normalizeClass(["action-chip action-detail", { disabled: row.authorization.status !== 1 }]),
                            disabled: row.authorization.status !== 1,
                            onClick: ($event: any) => (goShipInfo(row))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(View))
                              ]),
                              _: 1
                            }),
                            _cache[54] || (_cache[54] = _createElementVNode("span", null, "查看详情", -1)),
                            _createVNode(_component_el_icon, { class: "arrow" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ArrowRight))
                              ]),
                              _: 1
                            })
                          ], 10, _hoisted_58)
                        ]),
                        _: 2
                      }, 1032, ["disabled"]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "action-chip action-apply",
                        onClick: ($event: any) => (openApplyAuthorization(row))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Key))
                          ]),
                          _: 1
                        }),
                        _cache[55] || (_cache[55] = _createElementVNode("span", null, "获取授权", -1))
                      ], 8, _hoisted_59))
                ])
              ]))
            }), 128))
          ]))
    ])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createVNode(_component_el_pagination, {
        "current-page": page.current,
        "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((page.current) = $event)),
        "page-size": page.size,
        "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((page.size) = $event)),
        total: page.total,
        "page-sizes": [10, 20, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: "",
        onSizeChange: handleSizeChange,
        onCurrentChange: handlePageChange
      }, null, 8, ["current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: applyDialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((applyDialogVisible).value = $event)),
      class: "apply-dialog",
      title: "申请船舶授权",
      width: "540",
      "before-close": handleApplyDialogClose
    }, {
      default: _withCtx(() => [
        (applyResult.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createVNode(_component_el_result, {
                icon: "success",
                title: "提交成功",
                "sub-title": "等待用户授权"
              }, {
                extra: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: closeApplyDialog
                  }, {
                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                      _createTextVNode("关闭窗口", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (applyResult.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createVNode(_component_el_result, {
                  icon: "error",
                  title: "提交失败",
                  "sub-title": "请检查填写信息后重新提交"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Ship))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_66, _toDisplayString(selectedShip.value?.name), 1),
                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "title-sub" }, "为这艘船舶申请访问授权", -1))
                  ])
                ]),
                _createVNode(_component_el_form, { "label-width": "92" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "授权类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: applyParams.authorityId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((applyParams.authorityId) = $event)),
                          placeholder: "请选择授权类型",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shipAuthorityList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: _unref(getName)(item),
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "授权时段" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: datetimeRange.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((datetimeRange).value = $event)),
                          type: "datetimerange",
                          shortcuts: shortcuts,
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "申请缘由" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: applyParams.description,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((applyParams.description) = $event)),
                          type: "textarea",
                          rows: 4,
                          resize: "none",
                          placeholder: "请在此处填写申请缘由，便于客户更好地理解权限用途"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "submit-btn",
                      loading: submitting.value,
                      style: {"width":"100%"},
                      onClick: submitApply
                    }, {
                      default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                        _createTextVNode("提交申请", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})